export default "__VITE_ASSET__59f4f89d__"